import type { Observable } from 'rxjs';
import type { AddressBookTag } from '@integrations/address-books-tags/contracts/address-book-tag.contract';

import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

import { LANDINGS_SERVICE_API_BASE } from '@integrations/system-domains';
import { parseResponse } from '@integrations/shared/parse-response';
import { AddressBookTagCollectionResponseSchema } from '@integrations/address-books-tags/contracts/address-book-tag.contract';

@Injectable({ providedIn: 'root' })
export class AddressBooksTagsApiService {
    private readonly http = inject(HttpClient);
    private readonly baseUrl = inject(LANDINGS_SERVICE_API_BASE);

    public getTags(): Observable<AddressBookTag[]> {
        return this.http.get<unknown>(`${this.baseUrl}/email/tags`).pipe(
            map(
                (res) =>
                    parseResponse(res, AddressBookTagCollectionResponseSchema, {
                        endpoint: 'email/tags',
                        method: 'GET',
                    }).data
            )
        );
    }
}
